import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { toggleCollapsedNav } from 'actions/App';
import { ReactComponent as Logo } from 'assets/images/kealogo-text-bg.svg';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import './MobileHeader.scss';

const MobileHeader = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const t = useLocalizedMessage();
  const isOpen = useSelector(({ app }) => app.navCollapsed);
  const shopMatch = location.pathname.match(/^\/app\/([^/]+)/);
  const homePath = shopMatch ? `/app/${shopMatch[1]}/home` : '/';

  return (
    <header className="mobile-navigation-header d-flex d-xl-none" data-testid="mobile-navigation-header">
      <IconButton
        className="mobile-navigation-toggle"
        onClick={() => dispatch(toggleCollapsedNav(!isOpen))}
        aria-label={t('navigation.toggle')}
        aria-expanded={isOpen}
        aria-controls="mobile-navigation-drawer"
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
      <Link className="mobile-navigation-logo" to={homePath} aria-label="Kea Labs">
        <Logo role="img" aria-hidden="true" />
      </Link>
    </header>
  );
};

export default MobileHeader;
